"use client";

import { useEffect } from "react";

export default function ChunkLoadErrorHandler() {
  useEffect(() => {
    const handler = (event: ErrorEvent) => {
      // Check if the error is a ChunkLoadError
      const isChunkError = 
        event.message && 
        (event.message.includes("ChunkLoadError") || 
         event.message.includes("Loading chunk"));
      
      if (isChunkError) {
        console.log("ChunkLoadError detected, reloading page to recover...");
        // Prevent the error from showing in the console (optional)
        // event.preventDefault(); 
        
        // Reload the page to fetch the new chunks
        window.location.reload();
      }
    };

    // Also listen for unhandled promise rejections which might happen with dynamic imports
    const promiseHandler = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const isChunkError = 
        reason && 
        (reason.name === 'ChunkLoadError' || 
         (reason.message && reason.message.includes("Loading chunk")));

      if (isChunkError) {
        console.log("ChunkLoadError (Promise) detected, reloading page...");
        window.location.reload();
      }
    };

    window.addEventListener("error", handler);
    window.addEventListener("unhandledrejection", promiseHandler);

    return () => {
      window.removeEventListener("error", handler);
      window.removeEventListener("unhandledrejection", promiseHandler);
    };
  }, []);

  return null;
}
